import {
	HotTable,
	type HotTableProps,
	type HotTableRef,
} from "@handsontable/react-wrapper";
import { Box } from "@mui/material";
import { registerAllModules } from "handsontable/registry";
import { forwardRef } from "react";

registerAllModules();

interface CustomHotTableProps extends HotTableProps {}

const CustomHotTable = forwardRef<HotTableRef, CustomHotTableProps>(
	(props, ref) => {
		return (
			<Box>
				<HotTable
					ref={ref}
					licenseKey="non-commercial-and-evaluation"
					{...props}
				/>
			</Box>
		);
	},
);

CustomHotTable.displayName = "CustomHotTable";

export default CustomHotTable;
